// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-container {
  z-index: 20000;
  width: min(420px, calc(100vw - 24px));
}

.Toastify__toast-container--top-right {
  top: 12px;
  right: 12px;
}

.saas-toast {
  border-radius: 12px;
  min-height: 56px;
  padding: 10px 12px;
  box-shadow: 0 18px 40px rgba(2, 6, 23, 0.22);
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: rgba(255, 255, 255, 0.92);
  color: #111827;
  backdrop-filter: blur(8px);
}

.saas-toast-body {
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
  padding: 2px 2px 2px 8px;
}

.saas-toast-progress {
  height: 3px;
  opacity: 0.85;
}

.Toastify__toast--success {
  background: #22c55e;
  color: #f8fffb;
  border: 1px solid rgba(255, 255, 255, 0.28);
}

.Toastify__toast--error {
  background: #ef4444;
  color: #fff7f7;
  border: 1px solid rgba(255, 255, 255, 0.28);
}

.Toastify__toast--warning {
  border-left: 4px solid #f59e0b;
}

.Toastify__toast--info {
  border-left: 4px solid #3b82f6;
}

.Toastify__close-button {
  color: #6b7280;
  opacity: 0.75;
}

.Toastify__close-button:hover {
  opacity: 1;
}

.Toastify__toast--success .Toastify__close-button,
.Toastify__toast--error .Toastify__close-button {
  color: #ffffff;
  opacity: 0.9;
}

.Toastify__toast--success .saas-toast-progress {
  background: rgba(255, 255, 255, 0.55);
}

.Toastify__toast--error .saas-toast-progress {
  background: rgba(255, 255, 255, 0.55);
}

@media (max-width: 600px) {
  .Toastify__toast-container {
    left: 12px;
    right: 12px;
    width: auto;
  }
}

@media (prefers-color-scheme: dark) {
  .saas-toast {
    border: 1px solid rgba(148, 163, 184, 0.25);
    background: rgba(15, 23, 42, 0.9);
    color: #e5e7eb;
    box-shadow: 0 18px 44px rgba(2, 6, 23, 0.55);
  }

  .Toastify__close-button {
    color: #cbd5e1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/toast.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,uCAAuC;EACvC,qCAAqC;EACrC,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,iCAAiC;IACjC,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".Toastify__toast-container {\n  z-index: 20000;\n  width: min(420px, calc(100vw - 24px));\n}\n\n.Toastify__toast-container--top-right {\n  top: 12px;\n  right: 12px;\n}\n\n.saas-toast {\n  border-radius: 12px;\n  min-height: 56px;\n  padding: 10px 12px;\n  box-shadow: 0 18px 40px rgba(2, 6, 23, 0.22);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: rgba(255, 255, 255, 0.92);\n  color: #111827;\n  backdrop-filter: blur(8px);\n}\n\n.saas-toast-body {\n  font-size: 13px;\n  line-height: 1.4;\n  font-weight: 500;\n  padding: 2px 2px 2px 8px;\n}\n\n.saas-toast-progress {\n  height: 3px;\n  opacity: 0.85;\n}\n\n.Toastify__toast--success {\n  background: #22c55e;\n  color: #f8fffb;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n\n.Toastify__toast--error {\n  background: #ef4444;\n  color: #fff7f7;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n}\n\n.Toastify__toast--warning {\n  border-left: 4px solid #f59e0b;\n}\n\n.Toastify__toast--info {\n  border-left: 4px solid #3b82f6;\n}\n\n.Toastify__close-button {\n  color: #6b7280;\n  opacity: 0.75;\n}\n\n.Toastify__close-button:hover {\n  opacity: 1;\n}\n\n.Toastify__toast--success .Toastify__close-button,\n.Toastify__toast--error .Toastify__close-button {\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n.Toastify__toast--success .saas-toast-progress {\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.Toastify__toast--error .saas-toast-progress {\n  background: rgba(255, 255, 255, 0.55);\n}\n\n@media (max-width: 600px) {\n  .Toastify__toast-container {\n    left: 12px;\n    right: 12px;\n    width: auto;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .saas-toast {\n    border: 1px solid rgba(148, 163, 184, 0.25);\n    background: rgba(15, 23, 42, 0.9);\n    color: #e5e7eb;\n    box-shadow: 0 18px 44px rgba(2, 6, 23, 0.55);\n  }\n\n  .Toastify__close-button {\n    color: #cbd5e1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
